import React from 'react';
import Image from 'next/image';

const TrustedSection = ({trustData,pageName}) => {
  return (
    <section className={`${pageName ? 'bg-[#FFFAED] border-b border-borderColor py-3' : 'bg-[#F9F9FB] py-4 '}`}>
    <div className="container px-3">
      <div className="flex flex-wrap gap-5 justify-center items-center sm:gap-1">
        {trustData.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-2 w-[22%] border-r border-bordercolor last:border-r-0 sm:border-none sm:w-[48%] sm:gap-1"
          >
            <Image
              src={item.icon}
              alt={item.text}
              width={50}
              height={50}
              className="w-auto h-auto"
            />
            <p className="text-[#1A1A1A] text-sm sm:text-xs pr-2 sm:pr-0">
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
  )
}

export default TrustedSection;
